module.exports = __webpack_public_path__ + "img/3.92e42d6c.jpg";